import { forwardRef, type InputHTMLAttributes } from 'react'

// `sm` (36px) is desktop-only — fails the 44×44 touch-target rule on mobile.
type Variant = 'default' | 'mono'

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> & {
  variant?: Variant
  size?: 'sm' | 'md'
}

const Input = forwardRef<HTMLInputElement, Props>(
  (
    {
      variant = 'default',
      size = 'md',
      className = '',
      type = 'text',
      ...rest
    },
    ref
  ) => {
    const height =
      size === 'sm' ? 'min-h-[36px] text-sm' : 'min-h-[44px] text-base'
    const mono = variant === 'mono' ? 'font-mono tabular-nums' : ''
    return (
      <input
        ref={ref}
        type={type}
        className={`
          ${height} ${mono}
          w-full px-3 py-2 rounded-lg
          bg-cream-card border border-ink-200
          text-ink-900 placeholder:text-ink-400
          focus:outline-none focus:border-green-700 focus:ring-2 focus:ring-green-700/20
          disabled:opacity-60
          ${className}
        `}
        {...rest}
      />
    )
  }
)

Input.displayName = 'Input'

export default Input
